import React from 'react'
import PPEAnalyticsDashboard from './PPEAnalyticsDashboard'

const App = () => {
  return (
    <>
    <PPEAnalyticsDashboard/>
    </>
  )
}

export default App